import { render, staticRenderFns } from "./ProfileTobNav.vue?vue&type=template&id=31923295&scoped=true&"
import script from "./ProfileTobNav.vue?vue&type=script&lang=js&"
export * from "./ProfileTobNav.vue?vue&type=script&lang=js&"
import style0 from "./ProfileTobNav.vue?vue&type=style&index=0&id=31923295&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31923295",
  null
  
)

export default component.exports